// extracted by mini-css-extract-plugin
export var buttons = "styles-module--buttons--4JBZ3";
export var editIcon = "styles-module--editIcon--gNDUI";
export var editMediaButton = "styles-module--editMediaButton--M3904";
export var mediaContainer = "styles-module--mediaContainer--4SLY+";